module.exports = __webpack_public_path__ + "static/media/17jordanproskit.d82b053c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/17jordanproskit.png
// module id = 116
// module chunks = 0